/* ============================================================
   Footer custom — pointer-follow blob.
   Cada panel del footer custom tiene su propio blob interactivo
   que sigue al cursor con easing 1/20 (calcado del componente
   React de Aceternity).
   Soporta múltiples instancias (querySelectorAll).
============================================================ */
(function () {
  'use strict';

  function initPanel(panel) {
    var blob = panel.querySelector('.footer-custom__pointer');
    if (!blob) return;

    var curX = 0, curY = 0, tgX = 0, tgY = 0;

    function tick() {
      curX += (tgX - curX) / 20;
      curY += (tgY - curY) / 20;
      blob.style.transform =
        'translate(' + Math.round(curX) + 'px, ' + Math.round(curY) + 'px)';
      requestAnimationFrame(tick);
    }

    panel.addEventListener('mousemove', function (e) {
      var rect = panel.getBoundingClientRect();
      tgX = e.clientX - rect.left;
      tgY = e.clientY - rect.top;
    });

    tick();
  }

  function init() {
    var panels = document.querySelectorAll('.footer-custom__panel');
    for (var i = 0; i < panels.length; i++) initPanel(panels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
